<template>
  <div class="content">
    <div class="content_cont">
      <div>
        <img src="@/assets/160909.png" alt="" />
      </div>
      <div>
        <h2>今日贵金属典当价格表{{ todayDate }}</h2>
      </div>

      <div>
        <table
          width="100%"
          v-loading="loading"
          element-loading-text="数据请求中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <tr style="font-weight: bolder; height: 60px">
            <td width="100px">品种</td>
            <td width="200px">含量</td>
            <td width="250px">典当价格/元</td>
            <td width="150px">断当价格/元</td>
            <td width="250px">备注</td>
          </tr>
          <tr style="font-weight: bolder; height: 60px">
            <td rowspan="3">黄金</td>
            <td>足金（Au999）</td>
            <td>{{ Math.trunc(GoldPrice.last_price - 25) }}</td>
            <td>{{ Math.trunc(GoldPrice.last_price - 10) }}</td>
            <td>大额 80g 以上</td>
          </tr>
          <tr style="font-weight: bolder; height: 60px">
            <td>足金（Au999）</td>
            <td>{{ Math.trunc(GoldPrice.last_price - 25) }}</td>
            <td>{{ Math.trunc(GoldPrice.last_price - 15) }}</td>
            <td rowspan="5">根据品种的款式、成色、材质价格略有不同。</td>
          </tr>
          <tr style="font-weight: bolder; height: 60px">
            <td>18K（Au750）</td>
            <td>{{ Math.trunc((GoldPrice.last_price - 15) * 0.7) }}</td>
            <td>{{ Math.trunc((GoldPrice.last_price - 15) * 0.7) }}</td>
          </tr>
          <tr style="font-weight: bolder; height: 60px">
            <td>铂金</td>
            <td>PT999</td>
            <td>{{ Math.trunc(PtNum.last_price - 30) }}</td>
            <td>{{ Math.trunc(PtNum.last_price - 30) }}</td>
          </tr>
          <tr style="font-weight: bolder; height: 60px">
            <td>钯金</td>
            <td>PD999</td>
            <td>/</td>
            <td>/</td>
          </tr>
          <tr style="font-weight: bolder; height: 60px">
            <td>银</td>
            <td>足银</td>
            <td>{{ (Silver.last_price / 1000 - 1).toFixed(1) }}</td>
            <td>{{ (Silver.last_price / 1000 - 1).toFixed(1) }}</td>
          </tr>
        </table>
      </div>
      <div>
        <span>
          <h3 style="color: red">
            以上均为参考价格，报价以当天实际金价为准，重量精确至0.1
          </h3>
        </span>
      </div>
    </div>

    <!-- <div class="back">
          <EchartsTime/>
      </div> -->
  </div>
</template>
<script>
import dayjs from "dayjs";
// import EchartsTime from "@/components/realTimesGold/EchartsTime.vue"
export default {
  name: "Goldprice",
  data() {
    return {
      todayDate: "",
      GoldPrice: {},
      PtNum: {},
      Silver: {},
      loading: true,
    };
  },
  components: {
    // EchartsTime
  },
  methods: {
    //请求金价
    getGoldprice() {
      //黄金
      this.axios
        .get("/getGold/?app=finance.gold_price", {
          params: {
            goldid: "1053",
            version: 3,
            appkey: "62349",
            sign: "2b467d69432566985eec8e93f82e9008",
            format: "json",
          },
        })
        .then((res) => {
          this.loading = false;
          this.GoldPrice = res.data.result.dtList[1053];
          //铂金
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((res) => {
              this.PtNum = res.data.result.dtList[1056];

              //银
              this.axios
                .get("/getGold/?app=finance.gold_price", {
                  params: {
                    goldid: "1052",
                    version: 3,
                    appkey: "62349",
                    sign: "2b467d69432566985eec8e93f82e9008",
                    format: "json",
                  },
                })
                .then((res) => {
                  this.Silver = res.data.result.dtList[1052];
                })
                .then(() => {
                  this.$emit("child-goldprice", this.GoldPrice, this.PtNum, this.Silver);
                });
            });
        });
    },
  },
  created() {},
  mounted() {
    this.todayDate = dayjs().format("YYYY-MM-DD");
    this.getGoldprice();
  },
};
</script>
<style scoped>
.content_cont {
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content_cont h2 {
  color: red;
}
table {
  border-collapse: collapse;
}
td {
  height: 35px;
  border: 1px solid black;
  font-size: 15px;
  text-align: center;
}
.back {
  background-color: #ffffff;
}
</style>
